/**
 *
 * @export
 * @interface Room
 */
export interface Room {
  /**
   * 公寓楼
   * @type {string}
   * @memberof Room
   */
  buildingId?: string;
  /**
   * 创建日期
   * @type {string}
   * @memberof Room
   */
  createdAt?: string;
  /**
   * 描述信息
   * @type {string}
   * @memberof Room
   */
  description?: string;
  /**
   * 楼层号码(Floor NO)
   * @type {string}
   * @memberof Room
   */
  floorName?: string;
  /**
   *
   * @type {string}
   * @memberof Room
   */
  id?: string;
  /**
   * 房间名字(Unit No)
   * @type {string}
   * @memberof Room
   */
  name?: string;
  /**
   * pin code
   * @type {string}
   * @memberof Room
   */
  pinCode?: string;
  /**
   * - 空闲的: vacant - 被占用: occupied
   * @type {string}
   * @memberof Room
   */
  status?: RoomStatusEnum;
  /**
   * 修改日期
   * @type {string}
   * @memberof Room
   */
  updatedAt?: string;
}

export const RoomStatusEnum = {
  Unknown: 'unknown',
  Vacant: 'vacant',
  Occupied: 'occupied',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RoomStatusEnum = (typeof RoomStatusEnum)[keyof typeof RoomStatusEnum];

/**
 *
 * @export
 * @interface RoomCreateReq
 */
export interface RoomCreateReq {
  /**
   *
   * @type {Room}
   * @memberof RoomCreateReq
   */
  room?: Room;
}
/**
 *
 * @export
 * @interface RoomUpdateReq
 */
export interface RoomUpdateReq {
  /**
   *
   * @type {Room}
   * @memberof RoomUpdateReq
   */
  room?: Room;
  /**
   *
   * @type {string}
   * @memberof RoomUpdateReq
   */
  roomId?: string;
}
/**
 *
 * @export
 * @interface Rooms
 */
export interface Rooms {
  /**
   *
   * @type {Array<Room>}
   * @memberof Rooms
   */
  rooms?: Array<Room>;
  /**
   *
   * @type {number}
   * @memberof Rooms
   */
  total?: number;
}
/**
 *
 * @export
 * @interface PinCodeUpdateReq
 */
export interface PinCodeUpdateReq {
  /**
   *
   * @type {string}
   * @memberof PinCodeUpdateReq
   */
  id?: string;
  /**
   *
   * @type {number}
   * @memberof PinCodeUpdateReq
   */
  pinCode?: number;
}
